/**
 * Constants for Algolia advanced search session persistence
 */

export const STORAGE_KEY = "algolia_advanced_search_session";
export const SESSION_EXPIRY = 1000 * 60 * 30; // 30 minutes
